import script from "./GameBattle.vue?vue&type=script&setup=true&lang=js"
export * from "./GameBattle.vue?vue&type=script&setup=true&lang=js"

import "./GameBattle.vue?vue&type=style&index=0&id=19425d9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19425d9c"]])

export default __exports__